import { getRequest, postRequest } from '../endpoints';

export function viewReleaseFeature() {
    return postRequest(route('release-feature.view'));
}

export function getReleaseFeatures() {
    return getRequest(route('release-features.index'));
}
